import React from "react";
import GenericModal from "components/MainApp/atoms/Modals/GenericModal";

import styles from "./DeleteRoleModal.module.scss";
const DeleteRoleModal = ({ open, handleClose, handleCancel, handleConfirm, roleName}) => {
    const content = <div className={styles["delete-role-modal-content"]}>
        <div className={styles["delete-role-modal-title"]}>Al eliminar, se perderán los datos y permisos cargados.</div>
        <div className={styles["delete-role-modal-buttons"]}>
            <div onClick={handleCancel}>QUEDARME</div>
            <div onClick={handleConfirm}>SÍ, ELIMINAR</div>
        </div>
    </div>
    return (
      <div className={styles["delete-role-modal-container"]}>
          <GenericModal  title={`¿Está seguro que deseas eliminar el rol "${roleName}"?`}
            open={open}
            content={content}
            handleClose={handleClose}></GenericModal>
      </div>
    );
}


export default DeleteRoleModal;